export default __webpack_public_path__ + "static/media/mobile.ae411bf4.jpg";